import { CircularProgress } from "@mui/material";
import React from "react";

const BTNLoader = ({ isLoading = false, size = 20, color = "secondary" }) => {
  if (!isLoading) return null;
  return <CircularProgress size={size} color={color} />;
};

export default BTNLoader;
